/**
 * The one numeric comparator shared across the effects engine. A `resource`/`stat`
 * predicate (`predicate.ts`) and a `roll` atom's threshold check (`interpret.ts`) both
 * compare a number to a number under the same five operators; this is the single
 * definition both call, so the two can't drift.
 *
 * Pure number-on-number comparison — no domain types — so it lives in the rules
 * package next to its callers, never `shared/` (which can't import domain types
 * anyway).
 */

/** The closed set of comparison operators an effects predicate/roll may use. */
export type CmpOp = ">=" | ">" | "<=" | "<" | "==";

/** Compare two numbers under a {@link CmpOp}. Total — every operator is handled. */
export function compare(a: number, op: CmpOp, b: number): boolean {
  switch (op) {
    case ">=":
      return a >= b;
    case ">":
      return a > b;
    case "<=":
      return a <= b;
    case "<":
      return a < b;
    case "==":
      return a === b;
  }
}
